import { Capacitor } from '@capacitor/core';
import { Box, useTheme } from '@mui/material';
import { PropsWithChildren } from 'react';

import { ConditionalWrap } from '@frontend-libs/atomic';

import { PageSlideAnimation } from './page-slide-animation.component';
import { ViewSection } from './view-section.component';

export interface ViewProps {
  header?: React.ReactNode;
  enableAnimation?: boolean;
  backgroundColor?: string;
}

export const View = ({
  enableAnimation = false,
  ...props
}: PropsWithChildren<ViewProps>) => {
  const theme = useTheme();

  return (
    <ConditionalWrap
      condition={enableAnimation}
      wrap={(children) => <PageSlideAnimation>{children}</PageSlideAnimation>}
    >
      <Box
        id="view"
        sx={{
          pb: Capacitor.isNativePlatform()
            ? 'var(--safe-area-inset-bottom)'
            : undefined,
          width: '100vw',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
          backgroundColor:
            props.backgroundColor ?? theme.palette.background.default,
        }}
      >
        {props.header && (
          <ViewSection id="view-header" sx={{ px: 0 }}>
            {props.header}
          </ViewSection>
        )}

        <Box
          id="view-children"
          sx={{
            overflowY: 'auto',
            overflowX: 'hidden', // explicitly set this due to issues with carousel
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
          }}
        >
          {props.children}
        </Box>
      </Box>
    </ConditionalWrap>
  );
};
